module.exports = __webpack_public_path__ + "img/6.1.f422a1df.jpg";